
import React, { Component } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Fragment } from 'react';


export default class GridOtros extends Component {
    state = {
        detalles: {
            results: [],
            count: 0
        },
    }

    componentDidMount() {
        const { detalles } = this.props;
        this.setState({
            detalles: {
                results: detalles.length > 0 ? detalles : [],
                count: detalles.length > 0 ? detalles.length : 0,
            }
        });
    }

    render() {
        const { loader, page, onPageChange, onSortChange } = this.props;
        const { detalles } = this.state;

        return (
            <div className="row m-none">
                <div className="col-12">
                    <Fragment>
                        <Grid hover
                            pagination={false}
                            striped data={detalles}
                            loading={loader}
                        >
                            <TableHeaderColumn
                                dataField="id"
                                dataAlign="center"
                                isKey
                                dataSort
                                width="10%"
                                dataFormat={(cell, row, index) => {
                                    return row.descripcion;
                                }}
                            >
                                DESCRIPCIÓN
                            </TableHeaderColumn>
                        </Grid>
                    </Fragment>
                </div>
            </div>
        )
    }
}
